import axios from "axios";
import { TexProjetoForm } from "features/projetos/pages/ProjetoEditPage/TexDoProjetoPage/TexDoProjetoOffcanvas";

export async function saveTex(data: TexProjetoForm) {
  return await axios.post(`/Tex/Save`, data);
}